import React from 'react';
import { FadeIn } from './FadeIn';
import { Zap } from 'lucide-react';
export const ProblemSection = () => {
  return <section className="py-24 px-4 relative" data-id="element-163">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-96 h-96 bg-radial-gold opacity-50 pointer-events-none" data-id="element-164"></div>

      <div className="max-w-4xl mx-auto" data-id="element-165">
        <FadeIn data-id="element-166">
          <div className="flex items-center justify-center gap-3 mb-12" data-id="element-167">
            <Zap className="text-amber-accent" size={28} data-id="element-168" />
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-center text-brown-heading" data-id="element-169">
              La Física del{' '}
              <span className="gold-gradient-text" data-id="element-170">Sufrimiento</span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-171">
          <div className="bg-parchment-dark border border-sand rounded-2xl p-8 md:p-12 relative overflow-hidden group hover:border-gold/40 transition-colors duration-500" data-id="element-172">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-gold-light via-gold to-gold-antique" data-id="element-173"></div>

            <p className="text-xl text-brown leading-relaxed mb-6" data-id="element-174">
              El trauma no es solo un recuerdo; es una{' '}
              <strong className="text-gold-antique font-normal" data-id="element-175">
                carga electromagnética estancada
              </strong>{' '}
              en tus células.
            </p>

            <p className="text-lg text-brown-warm/70 leading-relaxed mb-6" data-id="element-176">
              Mientras esa carga siga ahí, tu mente inconsciente actúa como un
              imán que rechaza la felicidad y atrae el caos. Vives observando lo
              que te duele, lo que te falta y lo que te asusta.
            </p>

            <div className="mt-8 p-6 bg-parchment rounded-lg border border-amber-accent/20" data-id="element-177">
              <p className="text-brown-warm italic" data-id="element-178">
                "Estás atrapado en la 'física del sufrimiento' porque nadie te
                enseñó a cambiar el dial de tu propia antena."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};